// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610060321/js/" + chunkId + "." + {"44":"ba46d984","225":"8ad8fb4b","481":"18d82840","486":"a1ec76a5","770":"f65adf6c"}[chunkId] + ".0.6242536113849073.chunk.js";
};